import Reveal from '@/components/base/Reveal';
import { digZones } from '@/mocks/home';

function DigZones() {
  return (
    <section id="zones" className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-shell mx-auto px-4 md:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-primary-600 font-label">
              <i className="ri-layout-grid-line"></i>
              DEEP DIVE
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              深挖专区
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              把爆料按性质分成四个方向，方便你直接进入关心的那一类内幕。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {digZones.map((zone, index) => (
            <Reveal key={zone.key} delay={index * 80}>
              <a
                href="#latest"
                className="group flex flex-col h-full rounded-lg overflow-hidden border border-background-200 bg-background-100 cursor-pointer"
              >
                <div className="relative w-full h-44 overflow-hidden">
                  <img
                    src={zone.cover}
                    alt={`${zone.name}专区封面图`}
                    title={`网红爆料 ${zone.name}专区`}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-700"
                  />
                  <span className="absolute left-4 bottom-3 w-10 h-10 rounded-md bg-background-50/95 flex items-center justify-center text-primary-600">
                    <i className={`${zone.icon} text-xl`}></i>
                  </span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-lg font-semibold text-foreground-950">
                      {zone.name}
                    </h3>
                    <span className="text-xs text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {zone.count} 条
                    </span>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">
                    {zone.desc}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-xs text-primary-700 group-hover:gap-3 transition-all">
                    进入专区
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DigZones;